import { render, staticRenderFns } from "./PracticeDetails.vue?vue&type=template&id=8858e5f8&"
import script from "./PracticeDetails.vue?vue&type=script&lang=js&"
export * from "./PracticeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports